import { USERS_LOADING, USERS_LIST } from '../actions/listUsers';

const INITIAL_STATE = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 20,
    number: 0,
    loading: false,
};

const listUsers = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USERS_LOADING:
            return { ...state, loading: true };
        case USERS_LIST:
            return {
                ...state,
                ...action.list,
                loading: false,
            };
        default:
            return state;
    }
};
export default listUsers;
